import React, { FC, useCallback, useMemo } from 'react';
import { nullSafeGet } from '../../utils/DataAccessUtils';
import { Form } from '@ant-design/compatible';
import OWAsyncRadio from '../visual_radio_input/VisualRadioInput';
import { connect } from 'react-redux';
import { WORK_ORDERS_CRUD_ACTION_CREATORS } from '../../actions/work_orders_actions';
import { locationsRestCrudThunksForBuyer } from '../../thunks/locations_thunks';
import { getExchangeRate } from '../../thunks/currencies_thunks';
import { areasTopLevelForBuyer } from '../../thunks/areas_thunks';
import {
	handleLocation,
	handleLocationClick,
	LOCATION_STEP_PROPS,
} from './wo_creation_location_utils';
import ServiceRequestLocationRender, {
	renderLocationRecord,
} from '../service_request_location_render/ServiceRequestLocationRender';

const TC_NAME = 'WORK_ORDER_FORM_LOCATIONS_AUTOCOMPLETE';

const WOLocation: FC<any> = ({
	formData,
	goNextAfterBriefPause,
	setState,
	form,
	resetFieldAFter,

	companyConfig,
	locations,
	fetchLocations,
	fetchMultipleLocations,
	currentUser,
	fetchExchangeRate,
	fetchAreasTopLevel,
	fetchLocation,
}): React.ReactElement => {
	const { getFieldDecorator } = form;

	const lProps: LOCATION_STEP_PROPS = useMemo(
		() => ({
			fetchAreasTopLevel,
			goNextAfterBriefPause,
			locations,
			TC_NAME,
			fetchLocation,
			currentUser,
			fetchExchangeRate,
			setState,
			resetFieldAFter,
		}),
		[
			currentUser,
			fetchAreasTopLevel,
			fetchExchangeRate,
			fetchLocation,
			goNextAfterBriefPause,
			locations,
			resetFieldAFter,
			setState,
		]
	);

	const onLocationChange = useCallback(
		(id) => {
			handleLocation(lProps)(id);
		},
		[lProps]
	);

	const onLocationClick = useCallback(
		(id) => {
			handleLocationClick(lProps)(id, false);
		},
		[lProps]
	);

	return (
		<div key={1} className="newWorkOrderWizardPage__section">
			<h3 className="newWorkOrderWizardPage__title">Which location needs service?</h3>
			{nullSafeGet('config.newWorkOrder.step1.instructions', companyConfig) &&
			nullSafeGet('config.newWorkOrder.step1.instructions', companyConfig) !==
				"Tell us a bit about the issue you'd like addressed." ? (
				<h5>{nullSafeGet('config.newWorkOrder.step1.instructions', companyConfig)}</h5>
			) : null}
			<Form.Item style={{ width: '100%' }}>
				{getFieldDecorator(`locationId`, {
					rules: [
						{
							required: true,
							message: 'Please pick the location that needs service!',
						},
					],
					initialValue: nullSafeGet('locationId', formData),
				})(
					<OWAsyncRadio
						mode="default"
						fieldName="locationId"
						stateSlice={locations}
						onChange={onLocationChange}
						onClick={onLocationClick}
						targetCollectionName={TC_NAME}
						fetchMultiple={(ids, targetCollectionName) =>
							fetchMultipleLocations(ids, targetCollectionName)
						}
						fetchData={(
							search,
							targetCollectionName,
							pagination = null,
							sorting = null,
							filters = null,
							addToTargetCollection = false
						) =>
							fetchLocations(
								{ search: search || undefined },
								targetCollectionName,
								pagination,
								sorting,
								filters,
								addToTargetCollection
							)
						}
						renderRecord={(location) => renderLocationRecord(location, currentUser)}
						renderIcon={(location) => <ServiceRequestLocationRender location={location} />}
					/>
				)}
			</Form.Item>
		</div>
	);
};

const mapStateToProps = (state) => ({
	companyConfig: state.company_config.detail,
	locations: state.locations,
	currentUser: state.session.currentUser,
});

const mapDispatchToProps = (dispatch) => ({
	saveFormData: (formData) => dispatch(WORK_ORDERS_CRUD_ACTION_CREATORS.saveFormData(formData)),
	clearFormData: () => dispatch(WORK_ORDERS_CRUD_ACTION_CREATORS.clearFormData()),
	fetchLocations: (
		params,
		targetCollectionName,
		pagination,
		sorting,
		filters,
		addToTargetCollection
	) =>
		dispatch(
			locationsRestCrudThunksForBuyer.readLite(
				{ ...(params || {}), view: 'workOrderCreation' },
				targetCollectionName,
				pagination,
				sorting,
				filters,
				addToTargetCollection
			)
		),
	fetchMultipleLocations: (ids, targetCollectionName) =>
		dispatch(
			locationsRestCrudThunksForBuyer.readLite(
				{ ids, view: 'workOrderCreation' },
				targetCollectionName
			)
		),
	fetchExchangeRate: (c1, c2, userType) => dispatch(getExchangeRate(c1, c2)(userType)),
	fetchAreasTopLevel: (
		params,
		targetCollectionName,
		pagination,
		sorting,
		filters,
		addToTargetCollection
	) =>
		dispatch(
			areasTopLevelForBuyer(
				params,
				targetCollectionName,
				pagination,
				sorting,
				filters,
				addToTargetCollection
			)
		),
	fetchLocation: (id) => dispatch(locationsRestCrudThunksForBuyer.readOne(id)),
});

export default connect(mapStateToProps, mapDispatchToProps)(WOLocation);
